import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=17ca1fed&scoped=true&"
import script from "./Foot.vue?vue&type=script&lang=js&"
export * from "./Foot.vue?vue&type=script&lang=js&"
import style0 from "./Foot.vue?vue&type=style&index=0&id=17ca1fed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca1fed",
  null
  
)

export default component.exports